import React from "react";
import { Typography as MuiTypography } from "@mui/material";

export const AppTypography = ({
  variant = "body1",
  children,
  color = "#333333",
  fontWeight = 400,
  textAlign = "left",
  fontSize = "14px",
  lineHeight = "1.5",
  letterSpacing = "0.5px",
  textDecoration = "none",
  sx = {},
  ...props
}) => {
  const getDefaultStyles = () => {
    const baseStyles = {
      color: color,
      fontWeight,
      textAlign,
      lineHeight,
      letterSpacing,
      textDecoration,
      fontSize: fontSize,
    };
    return baseStyles;
  };

  return (
    <MuiTypography
      variant={variant}
      sx={{
        ...getDefaultStyles(),
        ...sx,
      }}
      {...props}
    >
      {children}
    </MuiTypography>
  );
};
